import React from "react";
import { Link } from "react-router-dom";

const AboutTwo = () => {
  return (
    <div className="space">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-xl-6">
            <div className="title-area mb-30">
              <span className="sub-title">
                <img src="assets/img/icon/title_left.svg" alt="shape" />
                Quem Somos
              </span>
              <h2 className="sec-title style2">
                Grupo Rocvel
              </h2>
              <p className="sec-text">
               Somos especialistas no segmento alimentício, com atuação em fornecimento de profissionais e soluções para padarias, restaurantes, cozinhas industriais e empresas de alimentação.
Nossa metodologia exclusiva de triagem garante mais agilidade, assertividade e qualidade na formação das equipes, atendendo empresas em todo o Brasil.
              </p>
            </div>
            <p className="about-desc">
              Entregamos candidatos aprovados em nossa triagem exclusiva e com toda a documentação pronta, reduzindo o tempo operacional do RH e acelerando as contratações.
            </p>
            <div className="btn-group">
              <Link to="/sobre-nos" className="global-btn style2">
                Conheça Nossa História <img src="assets/img/icon/right-icon.svg" alt="Seta Direita Rocvel" />
              </Link>
            </div>
          </div>
          <div className="col-xl-6">
            <div className="about-thumb2">
              <div className="about-img-1">
                <img src="assets/img/home/2.png" alt="Equipe de RH Grupo Rocvel" />
              </div>
              <div className="about-img-2">
                <img src="assets/img/home/3.png" alt="Consultoria Estratégica Rocvel" />
              </div>
              <div className="about-counter-wrap">
                <div className="about-icon">
                  <img src="assets/img/icon/about_icon2-1.svg" alt="Selo de Excelência" />
                  <div>
                    <h4 className="about-counter-text">Atuação</h4>
                  </div>
                </div>
                <p className="sec-desc">
                  Soluções estratégicas de RH em todo o território nacional com máxima credibilidade.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutTwo;